<!-- Sub-Menu -->
<div id="subMenu" class="sub-menu mat-elevation-z8">
  <div id="subMenuHeader" class="sub-menu-header" (click)="toggleSubMenu()">
    Sub Menu
    <div class="style-icon">
      <svg
        *ngIf="_isHidden"
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill="#666666"
      >
        <path
          d="m480-453-95-95q-11-11-27.5-11T329-548q-12 12-12 28.5t12 28.5l123 123q12 12 28 12t28-12l124-124q12-12 11.5-28T631-548q-12-11-28-11.5T575-548l-95 95Zm0 373q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
        />
      </svg>
      <svg
        *ngIf="!_isHidden"
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill="#666666"
      >
        <path
          d="m480-507 95 95q11 11 27.5 11t28.5-11q12-12 12-28.5T631-469L508-592q-12-12-28-12t-28 12L328-468q-12 12-11.5 28t12.5 28q12 11 28 11.5t28-11.5l95-95Zm0 427q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
        />
      </svg>
    </div>
  </div>
  <div class="sub-menu-bar" *ngIf="!_isHidden">
    <div
      id="new-dashboard-button"
      (click)="navigateTo('dashboard')"
      class="sub-menu-item"
      role="button"
      tabindex="0"
      aria-label="Navigate to Dashboard"
    >
      <svg
        class="icon-style"
        xmlns="http://www.w3.org/2000/svg"
        height="18px"
        viewBox="0 -960 960 960"
        width="18px"
        fill="#f2893e"
        aria-hidden="true"
      >
        <path
          d="M560-600q-17 0-28.5-11.5T520-640v-160q0-17 11.5-28.5T560-840h240q17 0 28.5 11.5T840-800v160q0 17-11.5 28.5T800-600H560ZM160-440q-17 0-28.5-11.5T120-480v-320q0-17 11.5-28.5T160-840h240q17 0 28.5 11.5T440-800v320q0 17-11.5 28.5T400-440H160Zm400 320q-17 0-28.5-11.5T520-160v-320q0-17 11.5-28.5T560-520h240q17 0 28.5 11.5T840-480v320q0 17-11.5 28.5T800-120H560Zm-400 0q-17 0-28.5-11.5T120-160v-160q0-17 11.5-28.5T160-360h240q17 0 28.5 11.5T440-320v160q0 17-11.5 28.5T400-120H160Z"
        />
      </svg>
      <span class="text-style" translate>Dashboard</span>
    </div>
    <div
      id="new-flip-button"
      (click)="navigateTo('historyFlip')"
      *ngIf="flipHasAccess"
      class="sub-menu-item"
      role="button"
      tabindex="0"
      aria-label="Navigate to FLI-P"
    >
      <svg
        class="icon-style"
        xmlns="http://www.w3.org/2000/svg"
        height="18px"
        viewBox="0 -960 960 960"
        width="18px"
        fill="#f2893e"
        aria-hidden="true"
      >
        <path
          d="M760-600q0 63-20.5 119.5T682-377q-11 14-11 30.5t12 28.5q13 12 30 10.5t28-15.5q46-57 72.5-128T840-600q0-80-26.5-151T741-879q-11-14-28-15.5T683-884q-12 12-12 28.5t11 30.5q37 47 57.5 104T760-600ZM400-500q42 0 71-29.5t29-70.5q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 41 29 70.5t71 29.5ZM200-240q0-17-11.5-28.5T160-280q-17 0-28.5 11.5T120-240q0 66 47 113t113 47q62 0 101.5-31t60.5-91q17-50 32.5-70t71.5-64q62-50 98-113t36-151q0-119-80.5-199.5T400-880q-119 0-199.5 80.5T120-600q0 17 11.5 28.5T160-560q17 0 28.5-11.5T200-600q0-85 57.5-142.5T400-800q85 0 142.5 57.5T600-600q0 68-27 116t-77 86q-52 38-81 74t-43 78q-14 44-33.5 65T280-160q-33 0-56.5-23.5T200-240Z"
        />
      </svg>
      <span class="text-style" translate>FLI-P</span>
    </div>
    <div
      id="new-reddi-button"
      (click)="navigateTo('historyReddi')"
      *ngIf="reddiHasAccess"
      class="sub-menu-item"
      role="button"
      tabindex="0"
      aria-label="Navigate to REDDI"
    >
      <svg
        class="icon-style"
        xmlns="http://www.w3.org/2000/svg"
        height="18px"
        viewBox="0 -960 960 960"
        width="18px"
        fill="#f2893e"
        aria-hidden="true"
      >
        <path
          d="M360-160q-19 0-34-11t-22-28l-92-241H80q-17 0-28.5-11.5T40-480q0-17 11.5-28.5T80-520h160q13 0 22.5 7t14.5 19l83 218 184-485q7-17 22-28t34-11q19 0 34 11t22 28l92 241h132q17 0 28.5 11.5T920-480q0 17-11.5 28.5T880-440H720q-13 0-22.5-7T683-466l-83-218-184 485q-7 17-22 28t-34 11Z"
        />
      </svg>
      <span class="text-style" translate>REDDI</span>
    </div>
    <div
      id="new-slat-button"
      (click)="navigateTo('historySlat')"
      *ngIf="slatHasAccess"
      class="sub-menu-item"
      role="button"
      tabindex="0"
      aria-label="Navigate to SLAT"
    >
      <svg
        class="icon-style"
        xmlns="http://www.w3.org/2000/svg"
        height="18px"
        viewBox="0 -960 960 960"
        width="18px"
        fill="#f2893e"
        aria-hidden="true"
      >
        <path
          d="M920-600q0 69-24.5 131.5T829-355q-12 14-30 15t-32-13q-13-13-12-31t12-33q30-38 46.5-85t16.5-98q0-51-16.5-97T767-781q-12-15-12.5-33t12.5-32q13-14 31.5-13.5T829-845q42 51 66.5 113.5T920-600Zm-182 0q0 32-10 61.5T700-484q-11 15-29.5 15.5T638-482q-13-13-13.5-31.5T633-549q6-11 9.5-24t3.5-27q0-14-3.5-27t-9.5-25q-9-17-8.5-35t13.5-31q14-14 32.5-13.5T700-716q18 25 28 54.5t10 61.5ZM360-440q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM40-200v-32q0-33 17-62t47-44q51-26 115-44t141-18q77 0 141 18t115 44q30 15 47 44t17 62v32q0 33-23.5 56.5T600-120H120q-33 0-56.5-23.5T40-200Z"
        />
      </svg>
      <span class="text-style" translate>SLAT</span>
    </div>

    <div
      id="new-review-button"
      (click)="navigateTo('reviews')"
      *ngIf="flipHasAccess || reddiHasAccess"
      class="sub-menu-item"
      role="button"
      tabindex="0"
      aria-label="Navigate to Reviews"
    >
      <svg
        class="icon-style"
        xmlns="http://www.w3.org/2000/svg"
        height="18px"
        viewBox="0 -960 960 960"
        width="18px"
        fill="#f2893e"
        aria-hidden="true"
      >
        <path
          d="M240-240 114-114q-10 10-22 5t-12-19v-672q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240Zm240-221 76 46q11 7 22-.5t8-20.5l-20-87 68-59q10-9 6-21.5T622-617l-89-7-35-82q-5-12-18-12t-18 12l-35 82-89 7q-14 1-18 13.5t6 21.5l68 59-20 87q-3 13 8 20.5t22 .5l76-46Z"
        />
      </svg>
      <span class="text-style" translate>REVIEWS</span>
      <svg
        class="icon-reviews"
        xmlns="http://www.w3.org/2000/svg"
        height="18px"
        viewBox="0 -960 960 960"
        width="18px"
        fill="#EA3323"
        aria-hidden="true"
        *ngIf="totalReviews > 0"
      >
        <path
          d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z"
        />
        <text
          x="50%"
          y="-250"
          fill="white"
          font-size="600"
          text-anchor="middle"
        >
          {{ totalReviews }}
        </text>
      </svg>
    </div>
  </div>
  <div class="sub-menu-back" *ngIf="!_isHidden">
    <app-link-button
      (click)="onNavigateBackClick()"
      color="#fff"
      showIcon="true"
      *ngIf="showBackButton"
      aria-label="Navigate back"
      >{{ 'Back' | translate }}</app-link-button
    >
  </div>
</div>
